/** Mapeia ícones do menu (Ant Design / routes) para nomes Lucide. */
const NAV_ICON_MAP: Record<string, string> = {
  user: 'user',
  gift: 'gift',
  'clock-circle': 'clock',
  'customer-service': 'headphones',
  phone: 'phone',
  bulb: 'lightbulb',
  'question-circle': 'circle-help',
  dashboard: 'layout-dashboard',
  appstore: 'app-window',
  calendar: 'calendar',
  'bar-chart': 'bar-chart-3',
  shop: 'store',
  'file-text': 'file-text',
  'file-search': 'file-search',
  search: 'search',
  database: 'database',
  'plus-circle': 'plus-circle',
  form: 'form-input',
  setting: 'settings',
  cloud: 'cloud',
  bug: 'bug',
  environment: 'map-pin',
  team: 'users',
  idcard: 'id-card',
  'log-out': 'log-out',
  logout: 'log-out',
  sun: 'sun',
  moon: 'moon',
};

export function resolveNavIcon(name?: string, fallback = 'user'): string {
  if (!name) {
    return fallback;
  }
  return NAV_ICON_MAP[name] ?? name;
}
